import { Navigate, useLocation, useParams } from 'react-router-dom'

/** Mantém links antigos funcionando sem carregar a tela de checkout removida. */
export function LegacyLandingCheckoutRedirect() {
  const { slug } = useParams<{ slug: string }>()
  const { search } = useLocation()

  return <Navigate to={`/campanha/${slug}/perfil${search}`} replace />
}
